import type { HttpClient } from '~/shared/api'
import { ApiService } from '~/shared/api'
import type { Logger } from '~/shared/interfaces'
import type { UserResumeFeedback } from '~/types/user/feedbacks'

export class FeedbacksMainService extends ApiService {
  constructor(
    http: HttpClient,
    private readonly logger: Logger,
  ) {
    super(http)
  }

  readonly urls = {
    feedbackSend: '/api/v1/yavagro/feedbacks/store',
  }

  async sendFeedback(params: UserResumeFeedback) {
    try {
      return await this.http.request({
        data: {
          feedback: params,
        },
        method: 'POST',
        url: this.urls.feedbackSend,
      })
    } catch (error) {
      this.logger.error('Failed to send feedback', error)
    }

  }
}
